import { useRoute } from 'wouter';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Skeleton } from '@/components/ui/skeleton';
import { Container } from '@/components/ui/container';
import TabbedInstallationForm from '@/components/installations/tabbed-installation-form';

export default function NewInstallationPage() {
  // Check if we have a proposal or customer ID from the URL
  const [matchProposalCustomer, paramsProposalCustomer] = useRoute<{
    proposalId: string;
    customerId: string;
  }>('/installations/new/:proposalId/:customerId');
  const [matchProposal, paramsProposal] = useRoute<{ proposalId: string }>(
    '/installations/new/:proposalId'
  );

  // Determine if we have initial data from URL
  const initialProposalId = matchProposalCustomer
    ? parseInt(paramsProposalCustomer.proposalId)
    : matchProposal
      ? parseInt(paramsProposal.proposalId)
      : undefined;

  const initialCustomerId = matchProposalCustomer
    ? parseInt(paramsProposalCustomer.customerId)
    : undefined;

  return (
    <>
      <Helmet>
        <title>New Installation | DomElec Solar</title>
      </Helmet>
      <Container className="py-8 max-w-7xl mx-auto">
        <Suspense fallback={<Skeleton className="h-[600px] w-full" />}>
          <TabbedInstallationForm proposalId={initialProposalId} customerId={initialCustomerId} />
        </Suspense>
      </Container>
    </>
  );
}
